
import { Badge, BadgeProps } from '@mui/material'
import React from 'react'

const BadgeWrapper: React.FC<BadgeProps> = ({ ...props }) => <Badge {...props} />

export default BadgeWrapper
